import React from 'react';
import { useAITTheme } from '../ui/theme';

const TripsHotelIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="156.72"
        y="116.62"
        width="43.37"
        height="43.37"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="237.98"
        y="116.62"
        width="43.37"
        height="43.37"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="319.25"
        y="116.62"
        width="43.37"
        height="43.37"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="156.72"
        y="199.65"
        width="43.37"
        height="43.37"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="237.98"
        y="199.65"
        width="43.37"
        height="43.37"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="319.25"
        y="199.65"
        width="43.37"
        height="43.37"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="156.72"
        y="282.69"
        width="43.37"
        height="43.37"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="237.98"
        y="282.69"
        width="43.37"
        height="43.37"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="319.25"
        y="282.69"
        width="43.37"
        height="43.37"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="156.72"
        y="365.72"
        width="43.37"
        height="43.37"
      />
      <path
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        d="M70.37,33.03v467.09h371.26V33.03H70.37ZM406.63,465.12h-125.28v-89.51h-43.37v89.51H105.37V68.03h301.26v397.09Z"
      />
      <rect
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        x="319.25"
        y="365.72"
        width="43.37"
        height="43.37"
      />
    </svg>
  );
};

export default TripsHotelIcon;
